// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  api_url: window.location.origin + '/svc/api' //Temporarioamente alterando para gerar o build certo
  //api_url: 'http://200.255.92.226:7990/svc/api' //testando na maquina local apontando para Duloren HM
  //api_url: 'http://dcl_duloren.ngrok.io/svc/api' //Essa deveria ser a URL de fato
};
